import { render, staticRenderFns } from "./edit-tag-modal.vue?vue&type=template&id=148a95f2&scoped=true"
import script from "./edit-tag-modal.vue?vue&type=script&lang=js"
export * from "./edit-tag-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-tag-modal.vue?vue&type=style&index=0&id=148a95f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a95f2",
  null
  
)

export default component.exports